import { render } from "./ScienceTerminal.vue?vue&type=template&id=601acd22"
import script from "./ScienceTerminal.vue?vue&type=script&lang=js"
export * from "./ScienceTerminal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__